import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Inventory Hub - Unified inventory management interface
 * Consolidates diamond inventory, import/export, and stock management
 */
import { useState } from 'react';
import { FaChartLine, FaGem, FaFileImport, FaToggleOn, FaToggleOff, FaDatabase } from 'react-icons/fa';
import { TabHub } from '../../components/Hubs/TabHub';
import InventoryDashboardTab from './InventoryHub/Dashboard/InventoryDashboardTab';
import DiamondInventory from './DiamondInventory';
import ImportManagement from './InventoryHub/ImportManagement';
import mockDataService from '../../services/mockDataService';
import { MockModeToggle, MockModeBadge, MockInfoBanner, MockInfoHeader, MockInfoTitle, CloseButton, MockInfoContent, MockInfoSection } from './InventoryHub.styles';
const InventoryHub = () => {
    const [activeTab, setActiveTab] = useState('dashboard');
    const [isMockMode, setIsMockMode] = useState(mockDataService.isMockMode());
    const [showMockInfo, setShowMockInfo] = useState(false);
    const [diamondFilters, setDiamondFilters] = useState(null);
    const handleToggleMockMode = () => {
        const newMode = mockDataService.toggleMockMode();
        setIsMockMode(newMode);
        window.location.reload();
    };
    const handleNavigateToTab = (tab, filters) => {
        if (filters) {
            setDiamondFilters(filters);
        }
        else {
            setDiamondFilters(null);
        }
        setActiveTab(tab);
    };
    const tabs = [
        {
            id: 'dashboard',
            label: 'Dashboard',
            description: 'Overview & Insights',
            icon: _jsx(FaChartLine, {}),
            component: _jsx(InventoryDashboardTab, { onNavigateToTab: handleNavigateToTab }),
            tourId: 'tour-inventory-dashboard-tab'
        },
        {
            id: 'diamonds',
            label: 'Diamonds',
            description: 'Manage Inventory',
            icon: _jsx(FaGem, {}),
            component: _jsx(DiamondInventory, { initialFilters: diamondFilters, onClearFilters: () => setDiamondFilters(null) }),
            tourId: 'tour-inventory-diamonds-tab'
        },
        {
            id: 'import',
            label: 'Import/Export',
            description: 'RAPNET & CSV',
            icon: _jsx(FaFileImport, {}),
            component: _jsx(ImportManagement, {}),
            tourId: 'tour-inventory-import-tab'
        }
    ];
    const mockToggle = (_jsxs(MockModeToggle, { id: "tour-inventory-mock-toggle", onClick: handleToggleMockMode, "$active": isMockMode, children: [isMockMode ? _jsx(FaToggleOn, {}) : _jsx(FaToggleOff, {}), _jsx("span", { children: isMockMode ? 'Mock Data ON' : 'Mock Data OFF' }), _jsx(FaDatabase, {})] }));
    const infoBanner = isMockMode && showMockInfo ? (_jsxs(MockInfoBanner, { children: [_jsxs(MockInfoHeader, { children: [_jsx(MockInfoTitle, { children: "Mock Inventory Demo Mode" }), _jsx(CloseButton, { onClick: () => setShowMockInfo(false), children: "\u00D7" })] }), _jsxs(MockInfoContent, { children: [_jsxs(MockInfoSection, { children: [_jsx("strong", { children: "What's Included" }), _jsxs("ul", { children: [_jsx("li", { children: "150 Realistic Diamonds with complete specifications" }), _jsx("li", { children: "Market-realistic shape distribution (45% Round, 15% Princess, etc.)" }), _jsx("li", { children: "Temporal data (import dates over 90 days for aging analysis)" }), _jsx("li", { children: "85% have GIA/AGS/IGI certificates" }), _jsx("li", { children: "50% have cost data for margin calculations" }), _jsx("li", { children: "Stock numbers STK00001-STK00150" }), _jsx("li", { children: "Total value: ~$1.2M" })] })] }), _jsxs(MockInfoSection, { children: [_jsx("strong", { children: "Fully Functional" }), _jsxs("ul", { children: [_jsx("li", { children: "Search and filter work perfectly" }), _jsx("li", { children: "All charts calculated from real distribution" }), _jsx("li", { children: "Action items generated from actual inventory" }), _jsx("li", { children: "All modals work (Reprice, Promote, Verify, etc.)" }), _jsx("li", { children: "Shares same toggle with Financial Hub" })] })] }), _jsxs(MockInfoSection, { children: [_jsx("strong", { children: "Toggle Off to return to real inventory" }), " - Your changes in mock mode are stored locally and won't affect production data. Your real 800+ diamonds will load from CosmosDB."] })] })] })) : (isMockMode ? (_jsx(MockModeBadge, { onClick: () => setShowMockInfo(!showMockInfo), children: "Demo Mode Active - Click for info" })) : null);
    return (_jsx(TabHub, { title: "Inventory Management Hub", subtitle: "Manage diamond inventory, imports, stock levels, and valuations - all in one place", activeTab: activeTab, tabs: tabs, onTabChange: (tabId) => setActiveTab(tabId), headerActions: mockToggle, infoBanner: infoBanner }));
};
export default InventoryHub;
